(function () {
  'use strict';
  document.querySelectorAll('[data-oc-carousel]').forEach(function (root) {
    var viewport = root.querySelector('.oc-carousel-viewport');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.oc-card'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.oc-carousel-dot'));
    var prevBtn = root.querySelector('.oc-carousel-btn--prev');
    var nextBtn = root.querySelector('.oc-carousel-btn--next');
    var counter = root.querySelector('.oc-carousel-counter');
    if (!viewport || !cards.length) return;

    var activeIndex = 0;
    var rafId = null;

    function update(index) {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = activeIndex === 0;
      if (nextBtn) nextBtn.disabled = activeIndex === cards.length - 1;
      if (counter) counter.textContent = 'Comparison ' + (activeIndex + 1) + ' of ' + cards.length;
    }

    function goTo(index) {
      var target = cards[Math.max(0, Math.min(index, cards.length - 1))];
      if (!target) return;
      viewport.scrollTo({ left: target.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
      update(cards.indexOf(target));
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { goTo(index); });
    });

    viewport.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var center = viewport.scrollLeft + viewport.clientWidth / 2;
        var nearest = 0;
        var nearestDistance = Infinity;
        cards.forEach(function (card, index) {
          var cardCenter = card.offsetLeft - viewport.offsetLeft + card.offsetWidth / 2;
          var distance = Math.abs(center - cardCenter);
          if (distance < nearestDistance) { nearest = index; nearestDistance = distance; }
        });
        update(nearest);
      });
    }, { passive: true });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1); }
    });

    window.addEventListener('resize', function () { goTo(activeIndex); });
    update(0);
  });
})();
